/* Onboarding bilingual translations. Canonical values are always English. */
export const t = {
  en: {
    nav: { switch: "TR" },
    hero: {
      kicker: "Private circle · Dubai",
      title: "Tell us about you.",
      lead: "A 4-minute round table before we meet in person. Everything stays in the group — that's the whole point.",
      meta: ["Strictly confidential", "Members only", "≈ 4 min"],
    },
    step: "Section",
    sections: {
      identity: { number: "01", title: "Identity", sub: "Kimlik" },
      table: { number: "02", title: "Round Table", sub: "Tanışma Turu" },
      synergy: { number: "03", title: "Synergy Fit", sub: "Sinerji" },
      contact: { number: "04", title: "Contact", sub: "İletişim" },
      personal: { number: "05", title: "Personal Touch", sub: "Kişisel" },
      commit: { number: "06", title: "Commitments", sub: "Taahhütler" },
    },
    f: {
      name: "Full name",
      role: "Your current role / activity",
      role_h: "e.g. Founder & CEO at MarinaDev Holdings",
      photo: "Profile photo (optional)",
      photo_h: "A friendly headshot helps the table connect a face to your name.",
      city: "City of residence",
      languages: "Languages you speak",
      sector: "Your sector & expertise",
      sub: "Your sub-specialties",
      sub_h: "Type and press Enter — add as many as you want",
      clients: "Your typical client profile",
      client_notes: "Anything to add about your client profile?",
      bring: "What you bring to the group",
      bring_h: "Be specific — what's unique to you in Dubai?",
      seek: "What you need / are looking for",
      seek_h: "What partners, profiles, or deals would unlock things for you?",
      desired: "Sectors you'd most love to find synergy with",
      desired_h: "Pick 2 or 3",
      live: "A live opportunity you'd like to bring to the first meeting (optional)",
      live_h: "It will be discussed in the 'Live Opportunities' agenda slot.",
      whatsapp: "WhatsApp",
      whatsapp_h: "With country code, e.g. +971 50 000 0000",
      email: "Email",
      linkedin: "LinkedIn profile (optional)",
      referrer: "How did you hear about The Synergy Table?",
      ref_who: "If invited by a member — who?",
      why: "Why this table, why now?",
      why_h: "2–3 sentences. This is the best filter for fit.",
    },
    commit: {
      rhythm: "I accept the **Round Table rhythm** — monthly meetings, at least 1 opportunity per quarter, written update if I'll be absent.",
      rules: "I commit to the **Rules of the Group** — confidentiality, mutual referral, protection of others' contacts, no conflict of interest, respectful communication.",
      comp: "I understand the **compensation model will be discussed in a separate meeting** — not at the first table.",
      organizer: "I'm open to take the **Group Organizer** role for a 6-month mandate when my turn comes.",
    },
    submit: "Send my profile",
    submitting: "Sending…",
    success: {
      title: "Welcome to the table.",
      body: "The Group Organizer has received your profile and will review it shortly. You'll get your login on WhatsApp.",
      hint: "You can close this window.",
    },
    error_default: "Something went wrong. Please try again.",
    err_required: "Please fill all required fields.",
  },
  tr: {
    nav: { switch: "EN" },
    hero: {
      kicker: "Özel çevre · Dubai",
      title: "Kendinden bahset.",
      lead: "Yüz yüze tanışmadan önce 4 dakikalık bir tanışma turu. Her şey grup içinde kalır — zaten amaç bu.",
      meta: ["Kesinlikle gizli", "Sadece üyeler", "≈ 4 dk"],
    },
    step: "Bölüm",
    sections: {
      identity: { number: "01", title: "Kimlik", sub: "Identity" },
      table: { number: "02", title: "Tanışma Turu", sub: "Round Table" },
      synergy: { number: "03", title: "Sinerji", sub: "Synergy Fit" },
      contact: { number: "04", title: "İletişim", sub: "Contact" },
      personal: { number: "05", title: "Kişisel", sub: "Personal Touch" },
      commit: { number: "06", title: "Taahhütler", sub: "Commitments" },
    },
    f: {
      name: "Ad Soyad",
      role: "Şu anki rolün / faaliyetin",
      role_h: "örn. MarinaDev Holdings Kurucu ve CEO",
      photo: "Profil fotoğrafı (isteğe bağlı)",
      photo_h: "Samimi bir fotoğraf masanın seni hatırlamasına yardımcı olur.",
      city: "Yaşadığın şehir",
      languages: "Konuştuğun diller",
      sector: "Sektörün ve uzmanlık alanın",
      sub: "Alt uzmanlık alanların",
      sub_h: "Enter tuşuna basarak istediğin kadar ekleyebilirsin",
      clients: "Hedef müşteri profilin",
      client_notes: "Müşteri profilin hakkında eklemek istediğin bir şey?",
      bring: "Gruba yapabileceğin katkı",
      bring_h: "Somut ve özgün ol — Dubai'de sana özgü olan nedir?",
      seek: "İhtiyacın olan / aradıkların",
      seek_h: "Hangi ortaklar, profiller veya anlaşmalar senin için kapıları açar?",
      desired: "En çok sinerji bulmak istediğin sektörler",
      desired_h: "2 veya 3 seç",
      live: "İlk toplantıya getirmek istediğin aktif bir fırsat (isteğe bağlı)",
      live_h: "'Aktif Fırsatlar' gündem maddesinde ele alınacak.",
      whatsapp: "WhatsApp",
      whatsapp_h: "Ülke kodu ile, örn. +971 50 000 0000",
      email: "E-posta",
      linkedin: "LinkedIn profili (isteğe bağlı)",
      referrer: "Synergy Table'dan nasıl haberin oldu?",
      ref_who: "Sizi davet eden üyenin adı?",
      why: "Neden bu masa, neden şimdi?",
      why_h: "2–3 cümle. Uyum değerlendirmesi için en kritik bölümdür.",
    },
    commit: {
      rhythm: "**Toplantı ritmini** kabul ediyorum — aylık toplantılar, çeyrek başına en az 1 fırsat, katılamayacağım durumlar için önceden yazılı bildirim.",
      rules: "**Grup kurallarına** sadık kalacağım — gizlilik, karşılıklı yönlendirme, kişilere saygı, çıkar çatışması yasağı, saygılı iletişim.",
      comp: "**Ücret modelinin ayrı bir toplantıda** ele alınacağını anlıyorum — ilk masada değil.",
      organizer: "Sıram geldiğinde 6 aylık **Grup Organizatörü** rolünü üstlenmeye açığım.",
    },
    submit: "Profilimi gönder",
    submitting: "Gönderiliyor…",
    success: {
      title: "Masaya hoş geldin.",
      body: "Grup Organizatörü profilini aldı, kısa süre içinde inceleyecek. Giriş bilgilerini WhatsApp üzerinden alacaksın.",
      hint: "Bu pencereyi kapatabilirsin.",
    },
    error_default: "Bir şeyler ters gitti. Lütfen tekrar dene.",
    err_required: "Lütfen zorunlu alanları doldur.",
  },
};

/* Canonical English values — always submitted to the backend. */
export const SECTORS_EN = [
  "Real Estate", "Legal & Corporate", "Finance & Investment",
  "Marketing & Brand", "Technology & Digital", "Construction",
  "Hospitality", "Wealth Management", "Other",
];
export const SECTORS_TR = [
  "Gayrimenkul", "Hukuk & Kurumsal", "Finans & Yatırım",
  "Pazarlama & Marka", "Teknoloji & Dijital", "İnşaat",
  "Konaklama", "Servet Yönetimi", "Diğer",
];

export const CLIENT_TYPES_EN = [
  "HNW Investors", "Family Offices", "Developers", "Corporates",
  "Government / Public", "Startups", "Individuals", "International Clients",
];
export const CLIENT_TYPES_TR = [
  "Yüksek Net Değerli Yatırımcılar", "Aile Ofisleri", "Geliştiriciler",
  "Kurumsal Şirketler", "Kamu / Devlet", "Girişimler",
  "Bireyler", "Uluslararası Müşteriler",
];

export const LANGUAGES_EN = [
  "English", "Arabic", "Turkish", "French", "Russian", "Italian", "Spanish", "Other",
];
export const LANGUAGES_TR = [
  "İngilizce", "Arapça", "Türkçe", "Fransızca",
  "Rusça", "İtalyanca", "İspanyolca", "Diğer",
];

export const REF_OPTIONS_EN = [
  "Invited by a member", "From the founder", "Event", "Other",
];
export const REF_OPTIONS_TR = [
  "Bir üye tarafından davet edildim", "Kurucudan", "Etkinlik", "Diğer",
];

/* Backward-compatible exports (default to EN). */
export const SECTORS = SECTORS_EN;
export const CLIENT_TYPES = CLIENT_TYPES_EN;
export const LANGUAGES = LANGUAGES_EN;

export function labelsFor(canonical, lang) {
  const map = {
    sectors: { en: SECTORS_EN, tr: SECTORS_TR },
    clients: { en: CLIENT_TYPES_EN, tr: CLIENT_TYPES_TR },
    languages: { en: LANGUAGES_EN, tr: LANGUAGES_TR },
    ref: { en: REF_OPTIONS_EN, tr: REF_OPTIONS_TR },
  };
  return map[canonical]?.[lang] || map[canonical]?.en;
}
